import {
	CHECKBOX_ATTR_CHECKED,
	CHECKBOX_ATTR_ID, CHECKBOX_COMMANDS, CHECKBOX_ATTR_ENABLED, CHECKBOX_OUT_COMMANDS, COMPONENT_ATTR_CAN_REVIEW, COMPONENT_ATTR_NEW_VALUE,
	COMPONENT_NAME
} from '../constants';
import { toWidget } from 'ckeditor5/src/widget';
import { isEmpty, isNil, isNull, isUndefined } from 'lodash';

export const downcastCheckBox = ( editor, { asWidget } ) => {
	return ( modelElement, { writer } ) => {
		const isEnabledAttr = modelElement.getAttribute( CHECKBOX_ATTR_ENABLED );
		const checkedAttr = modelElement.getAttribute( CHECKBOX_ATTR_CHECKED );
		const newValueAttr = modelElement.getAttribute( COMPONENT_ATTR_NEW_VALUE );
		const canReviewAttr = modelElement.getAttribute( COMPONENT_ATTR_CAN_REVIEW );
		const canReview = typeof canReviewAttr === 'string' ? canReviewAttr === 'true' : Boolean( canReviewAttr );
		const newValue = typeof newValueAttr === 'string' ? newValueAttr === 'true' : Boolean( newValueAttr );
		const checked = typeof checkedAttr === 'string' ? checkedAttr === 'true' : Boolean( checkedAttr );
		const isEnabled = typeof isEnabledAttr === 'string' ? isEnabledAttr === 'true' : Boolean( isEnabledAttr );
		const id = modelElement.getAttribute( CHECKBOX_ATTR_ID );
		const hasNewValue = !isNil( newValueAttr ) && !isEmpty( newValueAttr );
		const valuesAreEqual = newValue === checked;

		const defaultAttributes = {};
		if ( asWidget ) {
			if ( !isNil( newValue ) ) {
				defaultAttributes[ 'data-new-value' ] = newValueAttr;
				defaultAttributes[ 'data-can-review' ] = canReview;
			}
		}

		const checkBoxElement = writer.createContainerElement( 'span', {
			class: 'dw-checkbox',
			checked,
			id
		} );

		if ( !isUndefined( isEnabledAttr ) && !isEnabled ) {
			writer.addClass( 'dw-checkboxDisabled', checkBoxElement );
		}

		const diffContainer = writer.createContainerElement( 'span', {
			class: 'dw-checkbox-diff-container'
		} );

		let buttonsReview = null;
		if ( asWidget ) {
			if ( hasNewValue && canReview && !isNil( document ) && !valuesAreEqual ) {
				const acceptClick = () => {
					editor.execute( CHECKBOX_COMMANDS.DIFF, { name: id } );
					editor.execute( CHECKBOX_COMMANDS.CHANGE, { checked: newValue, id } );
					editor.fire( CHECKBOX_OUT_COMMANDS.DIFF_REVIEW, { type: 'accept', id, checked: newValue } );
				};
				const rejectClick = () => {
					editor.execute( CHECKBOX_COMMANDS.DIFF, { name: id } );
					editor.fire( CHECKBOX_OUT_COMMANDS.DIFF_REVIEW, { type: 'reject', id, checked } );
				};

				buttonsReview = writer.createUIElement( 'span', { class: 'checkbox-buttons' }, function( domDocument ) {
					const domElement = this.toDomElement( domDocument );
					const acceptBtn = document.createElement( 'button' );
					acceptBtn.classList.add( 'btn', 'btn-accept' );
					acceptBtn.innerText = editor.t( 'Accept' );
					acceptBtn.onclick = acceptClick;
					domElement.appendChild( acceptBtn );

					const rejectBtn = document.createElement( 'button' );
					rejectBtn.classList.add( 'btn', 'btn-reject' );
					rejectBtn.innerText = editor.t( 'Reject' );
					rejectBtn.onclick = rejectClick;
					domElement.appendChild( rejectBtn );

					return domElement;
				} );
			}
		}

		if ( hasNewValue ) {
			if ( !valuesAreEqual ) {
				const checkBoxWithOldValue = writer.createContainerElement( 'span', {
					...defaultAttributes,
					class: checked ? 'diff-checkbox dw-diff-checkbox-red-active' : 'diff-checkbox dw-diff-checkbox-red'
				} );
				const checkBoxWithNewValue = writer.createContainerElement( 'span', {
					class: newValue ? 'diff-checkbox dw-diff-checkbox-disabled-active' : 'diff-checkbox dw-diff-checkbox-disabled'
				} );
				writer.insert( writer.createPositionAt( diffContainer, 'end' ), checkBoxWithOldValue );
				writer.insert( writer.createPositionAt( diffContainer, 'end' ), checkBoxWithNewValue );
			}
		}

		if ( checked ) {
			writer.addClass( 'dw-checkboxActive', !valuesAreEqual ? checkBoxElement : diffContainer );
		}
		if ( !checked ) {
			writer.removeClass( 'dw-checkboxActive', !valuesAreEqual ? checkBoxElement : diffContainer );
		}

		if ( !isNull( buttonsReview ) ) {
			writer.insert( writer.createPositionAt( diffContainer, 'end' ), buttonsReview );
		}
		if ( asWidget && !hasNewValue ) {
			toWidget( checkBoxElement, writer, { widgetLabel: COMPONENT_NAME } );
		}

		return hasNewValue ? diffContainer : checkBoxElement;
	};
};
